module.exports = __webpack_public_path__ + "img/electric.8a0188a9.png";